import { render, staticRenderFns } from "./VehicleChip.vue?vue&type=template&id=69890796&scoped=true"
import script from "./VehicleChip.vue?vue&type=script&lang=js"
export * from "./VehicleChip.vue?vue&type=script&lang=js"
import style0 from "./VehicleChip.vue?vue&type=style&index=0&id=69890796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69890796",
  null
  
)

export default component.exports